/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import{backIn as o}from"./back.js";const t=t=>(t*=2)<1?.5*o(t):.5*(2-Math.pow(2,-10*(t-1)));export{t as anticipate};
//# sourceMappingURL=anticipate.js.map
